import React, { Ref, useMemo } from 'react';
import classnames from 'classnames';
import { v4 as uuid } from 'uuid';

interface RadioButtonProps {
    value: string;
    label?: string;
    id?: string;
    inputRef?: Ref<HTMLInputElement>;
    name?: string;
    describedBy?: string;
    selectedOption: string | undefined;
    onChange: (value: string) => void;
    required: boolean;
    error: boolean;
}

const RadioButton = ({
    value,
    name,
    selectedOption,
    onChange,
    id,
    inputRef,
    label,
    required,
    error,
    describedBy,
}: RadioButtonProps): JSX.Element => {
    const inputId = useMemo(() => id || uuid(), [id]);

    return (
        <div className={classnames('sgw-radio-option', { 'sgw-radio-option__error': error })}>
            {/* eslint-disable-next-line jsx-a11y/role-supports-aria-props */}
            <input
                type="radio"
                value={value}
                name={name}
                checked={value === selectedOption}
                onChange={(event) => {
                    onChange(event.target.value);
                }}
                id={inputId}
                ref={inputRef}
                aria-describedby={describedBy}
                required={required}
                aria-invalid={error}
            />
            <label htmlFor={inputId}>{label || value}</label>
        </div>
    );
};

export default RadioButton;
